export default "__VITE_ASSET__pXHN3Loo__"